import React from 'react';
import { Navigate, useParams, useLocation, useNavigate } from 'react-router-dom';
import { isSignedIn } from '../utils/sessions';
import history from '../utils/history';

export default function RouteElement({ auth, anon, redirectPath, component: Component, title, ...rest }) {
    const params = useParams();
    const location = useLocation();
    const navigate = useNavigate();

    setPageTitle(
        title,
        params.key || params.id || null,
        params.tab || params.search || params.date || null
    );

    if (auth && !isSignedIn()) {
        return <Navigate to={redirectPath || '/sign-in'} state={{ referrer: location }} replace />;
    }
    if (anon && isSignedIn()) {
        return <Navigate to={redirectPath || '/'} state={{ referrer: location }} replace />;
    }

    const match = { params, path: location.pathname, url: location.pathname };
    const historyCompat = {
        push: navigate,
        replace: (to) => navigate(to, { replace: true }),
        go: (n) => navigate(n),
        goBack: () => navigate(-1),
        goForward: () => navigate(1),
        block: history.block.bind(history),
        listen: (callback) => history.listen(({ action, location }) => callback(location, action)),
        location
    };

    return <Component {...rest} match={match} location={location} history={historyCompat} />;
}

function setPageTitle(title, key, tab) {
    if (!!title)
        document.title =
            (key ? (Number(key) ? '#' : '') + key + ' ' : '') +
            title +
            (!!tab ? ` (${tab})` : '') +
            ' - Cremation Manager';
    else document.title = 'Cremation Manager';
}
